import { useGetCustomerQuery } from '../api';
import { openMailto } from '../utils/mailto';

/**
 * Хук для отправки email в поддержку (mailto).
 * Использует email из профиля авторизованного клиента.
 */
export const useSupportEmail = () => {
    const { data: customer } = useGetCustomerQuery();

    const sendEmail = (subject: string, body?: string) => {
        const processedSubject = subject.replace('{customer_id}', String(customer?.id ?? ''));
        openMailto({
            email: customer?.support_email,
            subject: processedSubject,
            body,
        });
    };

    return { sendEmail, supportEmail: customer?.support_email };
};
